import { byABTestingFactory, byDeviceFactory, byCountryFactory } from './rules';
export var createRules = function (config, factories) {
    return factories.map(function (ruleFactory) { return ruleFactory(config); });
};
export var applyRules = function (payload, rules) {
    // tslint:disable-next-line:prefer-for-of increment-decrement
    for (var i = 0; i < rules.length; i++) {
        if (!rules[i](payload)) {
            return false;
        }
    }
    return true;
};
export var shouldShowDCF = function (config, payload) {
    var rules = createRules(config, [byABTestingFactory, byDeviceFactory, byCountryFactory]);
    return applyRules(payload, rules);
};
//# sourceMappingURL=applyRules.js.map